import { WeekDay } from '@app-types/index';
import { weekDays } from '@data/weekDays';
import { TimeSlotConfigurationsDataType } from '@modules/timetable';

export const getApplyToAll = (timeSlotConfigurationDefaultValues: TimeSlotConfigurationsDataType): boolean => {
  let applyToAll = false;
  let firstRun = true;
  Object.values(timeSlotConfigurationDefaultValues).forEach((configurationForADay, index) => {
    if ((firstRun && !applyToAll) || applyToAll) {
      const previousConfiguration = timeSlotConfigurationDefaultValues[weekDays[index - 1] as WeekDay];

      if (previousConfiguration) {
        previousConfiguration.forEach((configuration, configurationIndex) => {
          if (
            configurationForADay[configurationIndex] &&
            configurationForADay[configurationIndex].startTime.hour() === configuration.startTime.hour() &&
            configurationForADay[configurationIndex].startTime.minute() === configuration.startTime.minute() &&
            configurationForADay[configurationIndex].endTime.hour() === configuration.endTime.hour() &&
            configurationForADay[configurationIndex].endTime.minute() === configuration.endTime.minute()
          ) {
            applyToAll = true;
          } else if (!firstRun) {
            applyToAll = false;
          }

          firstRun = false;
        });
      }
    }
  });

  return applyToAll;
};
